import { Dialog, DialogContent } from '@mui/material'
import React, { useState } from 'react'
import NotesGroupForm from './NotesGroupForm'

function NoteGroupList({notesGroupList,callBack}) {

    const[dialogStatus,setDialogStatus] = useState(false);

    return (
    <>
        <button className='btn btn-warning' onClick={()=>setDialogStatus(true)} >Group List</button>
        <Dialog
            open={dialogStatus}
            keepMounted
            onClose={()=>setDialogStatus(false)}
            fullWidth={true}
            maxWidth="sm"
            
        >
            <div style={{backgroundColor:"#000"}} className='border border-1 border-primary'>
            
                {notesGroupList.map((notesGroup)=>
                    <NotesGroupForm data={notesGroup} callBack={callBack}/>
                )}
            
            </div>
        </Dialog>
        
    </>
  )
}

export default NoteGroupList